import { ErrorComponent as TsErrorComponent } from "@tanstack/react-router";
import { useMutation } from "@tanstack/react-query";
import { client } from "@/client";
import { FullStory } from "@fullstory/browser";
import { useEffect } from "react";

export function ErrorComponent({ error }) {
  const sendError = useMutation({
    ...client.dashboardAlerts.create.asMutationOptions(),
  });

  useEffect(() => {
    const playbackAtThisMomentInTime = FullStory("getSession", {
      format: "url.now",
    });

    console.log("error: ", error);
    console.log("stack trace: ", error?.stack);
    console.log("playbackAtThisMomentInTime: ", playbackAtThisMomentInTime);
    if (playbackAtThisMomentInTime !== null) {
      if (error?.message == "Bad Gateway") {
        return;
      }
      sendError.mutateAsync({
        requestBody: {
          errorMessages: error.message,
          stackTrace: error.stack,
          fullStoryUrl: playbackAtThisMomentInTime,
        },
      });
    }
  }, [error]);

  return <TsErrorComponent error={error} />;
}
